import {GQLQueryProvider} from "../gqlModel/GQLQueryProvider";
import {QuizQuestionModelType} from "./QuizQuestionModel";
import {createQuizQuestion, updateQuizQuestion} from "./graphql/mutations";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";

interface QuizQuestionGqlProviderDeps {
    dataClientService: IDataClientService;
    authService: IAuthService;
}

export class QuizQuestionGQLProvider extends GQLQueryProvider {
    private readonly dataClientService: IDataClientService;
    private readonly authService: IAuthService;

    constructor({dataClientService, authService}: QuizQuestionGqlProviderDeps) {
        super();
        this.dataClientService = dataClientService;
        this.authService = authService;
    }

    save = async (quizQuestion: QuizQuestionModelType): Promise<QuizQuestionModelType> => {
        const payload = {
            id: quizQuestion.id,
            ownerIdAndWsId: quizQuestion.ownerIdAndWsId,
            quizId: quizQuestion.quizId,
            text: quizQuestion.text,
            options: JSON.stringify(quizQuestion.options),
        };

        const mutation = quizQuestion.isNew ? createQuizQuestion : updateQuizQuestion;
        const savedQuizQuestion = await queryGqlApi(
            mutation,
            {input: payload},
            this.dataClientService,
            this.authService,
            'quiz'
        );

        return savedQuizQuestion as QuizQuestionModelType;
    }
}
